import * as React from "react"

const BalanceScaleIcon = ({...props}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
    <path
      fill="#ffc008"
      d="M61.72 39c.65 0 1.13.61.97 1.24l-.5 2c-.11.45-.51.76-.97.76H42.78c-.46 0-.86-.31-.97-.76l-.5-2a.998.998 0 0 1 .97-1.24H61.72z"
    />
    <path fill="#65bc6a" d="M62 33v3h-7v-3h4.79zM49 33v3h-7v-3h2.21z" />
    <path fill="#398f3e" d="M42.28 39H42v-3h7v3z" />
    <path fill="#dbe4eb" d="M55 36v3h-6v-6h6z" />
    <path
      fill="#ffa10b"
      d="M61.72 39H51.297c-2.751 1.882-5.961 2.894-9.673 2.495l.186.745c.11.45.51.76.97.76h18.44c.46 0 .86-.31.97-.76l.5-2a.998.998 0 0 0-.97-1.24z"
    />
    <path
      fill="#309930"
      d="M59.79 33h-2.672A28.573 28.573 0 0 1 55 35.693V36h7v-3h-2.21z"
    />
    <path fill="#167c16" d="M55.12 36H55v3h7v-3z" />
    <path
      fill="#a29292"
      d="M51.297 39H55v-3.307c-1.129 1.264-2.361 2.389-3.703 3.307z"
    />
    <path fill="#dbe4eb" d="M15 36v3H9v-6h6z" />
    <path
      fill="#ffc008"
      d="m22.69 40.24-.5 2c-.11.45-.51.76-.97.76H2.78c-.46 0-.86-.31-.97-.76l-.5-2A.998.998 0 0 1 2.28 39h19.44c.65 0 1.13.61.97 1.24z"
    />
    <path fill="#65bc6a" d="M9 33v3H2v-3h2.21zM22 33v3h-7v-3h4.79z" />
    <path fill="#398f3e" d="M2.28 39H2v-3h7v3z" />
    <path
      fill="#ffa10b"
      d="M21.72 39H11.297c-2.751 1.882-5.961 2.894-9.673 2.495l.186.745c.11.45.51.76.97.76h18.44c.46 0 .86-.31.97-.76l.5-2a.998.998 0 0 0-.97-1.24z"
    />
    <path
      fill="#309930"
      d="M19.79 33h-2.672A28.573 28.573 0 0 1 15 35.693V36h7v-3h-2.21z"
    />
    <path fill="#167c16" d="M15.12 36H15v3h7v-3z" />
    <path
      fill="#a29292"
      d="M11.297 39H15v-3.307c-1.129 1.264-2.361 2.389-3.703 3.307z"
    />
    <path
      fill="#fbde08"
      d="M36 10v1c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h6c.55 0 1 .45 1 1z"
    />
    <path fill="#ffc008" d="M29 12h6v7h-6z" />
    <path fill="#fbde08" d="M29 12h3v7h-3z" />
    <path fill="#ffc008" d="M36 10v1c0 .55-.45 1-1 1h-3V9h3c.55 0 1 .45 1 1z" />
    <path
      fill="#fff177"
      d="m9.04 39-3.68 4H2.64l3.68-4zM49.04 39l-3.68 4h-2.72l3.68-4z"
    />
    <path
      fill="#fbde08"
      d="M47 60H17s5.78 0 11.76-8.66C29.48 52.35 30.66 53 32 53s2.52-.65 3.24-1.66C41.22 60 47 60 47 60zM34 19v26.54c-.59-.34-1.27-.54-2-.54s-1.41.2-2 .54V19h4z"
    />
    <path
      fill="#fff177"
      d="M30 19v26.54a3.99 3.99 0 0 1 2-.54V19h-2zm-3.69 41h2.67c1.64-2.23 2.64-4.67 3.02-7.01-.04.01-.07.01-.11.01-.69 0-1.34-.18-1.9-.48-.34 2.15-1.31 4.45-2.9 6.54-.25.33-.5.64-.78.94z"
    />
    <circle cx={32} cy={5} r={4} fill="#fbde08" />
    <path
      fill="#ffc008"
      d="M36 5c0 2.21-1.79 4-4 4-1.43 0-2.68-.75-3.38-1.87.51.24 1.07.37 1.66.37a3.991 3.991 0 0 0 3.38-6.13C35.04 1.99 36 3.38 36 5zm-4 40c2.21 0 4 1.79 4 4 0 1.1-.45 2.1-1.17 2.83C34.1 52.55 33.1 53 32 53s-2.1-.45-2.83-1.17A4.025 4.025 0 0 1 28 49c0-2.21 1.79-4 4-4z"
    />
    <path
      fill="#ffa10b"
      d="M36 49c0 1.1-.45 2.1-1.17 2.83C34.1 52.55 33.1 53 32 53s-2.1-.45-2.83-1.17c-.14-.14-.27-.3-.38-.46.43.16.89.25 1.37.25 1.1 0 2.1-.45 2.83-1.16.72-.74 1.17-1.74 1.17-2.84 0-.89-.29-1.71-.78-2.37C34.91 45.81 36 47.28 36 49z"
    />
    <path
      fill="#ffc008"
      d="M47 60a.998.998 0 0 1 1 1v1c0 .55-.45 1-1 1H17c-.55 0-1-.45-1-1v-1a.998.998 0 0 1 1-1h30zm-9.124-5.36c-1.322 2.098-2.972 3.936-4.91 5.36H47s-4.19-.02-9.124-5.36z"
    />
    <path
      fill="#ffa10b"
      d="M47.2 60.02c-.06-.01-.13-.02-.2-.02H32.966c-2.247 1.651-4.882 2.73-7.839 3H47c.55 0 1-.45 1-1v-1c0-.48-.34-.89-.8-.98z"
    />
    <path
      fill="#f9f4d2"
      d="M31.125 49.125c1.287 0 1.289-2 0-2-1.287 0-1.289 2 0 2z"
    />
    <path
      fill="#f9f5e8"
      d="M31.25 5c1.287 0 1.289-2 0-2-1.287 0-1.289 2 0 2z"
    />
    <path fill="#fff177" d="M29 12v7l-19-3z" />
    <path fill="#fbde08" d="m54 16-19 3v-7z" />
    <path
      fill="#ffc008"
      d="m54 16-8.201-1.727c-3.057 2.339-6.906 3.658-10.799 4.705V19l19-3z"
    />
    <path
      fill="#472b3c"
      d="M2 32a1 1 0 0 0-1 1v5.468a1.984 1.984 0 0 0-.659 2.016l.5 2A1.995 1.995 0 0 0 2.781 44h18.438c.92 0 1.718-.623 1.94-1.516l.501-2a1.99 1.99 0 0 0-.66-2.016V33a1 1 0 0 0-1-1h-1.568l-6.586-14.381 14.998 2.368A.92.92 0 0 0 29 20v25.026c-1.207.914-2 2.348-2 3.974 0 2.757 2.243 5 5 5 1.188 0 2.265-.434 3.124-1.128 2.256 3.034 4.465 4.94 6.36 6.128H22.522c1.497-.939 3.189-2.313 4.946-4.346a1.002 1.002 0 0 0-1.514-1.308c-4.745 5.491-8.876 5.652-8.961 5.654l-.006.001A2.003 2.003 0 0 0 15 61v1c0 1.103.897 2 2 2h30c1.103 0 2-.897 2-2v-1c0-1.1-.893-1.994-1.991-1.999V59c-.053-.001-5.159-.195-10.58-7.729A4.934 4.934 0 0 0 37 49c0-1.627-.793-3.061-2-3.974V22a1 1 0 1 0-2 0v22.101a4.995 4.995 0 0 0-2 0V20h4a.912.912 0 0 0 .156-.013l14.998-2.368L43.568 32H42a1 1 0 0 0-1 1v5.468a1.984 1.984 0 0 0-.659 2.016l.5 2A1.995 1.995 0 0 0 42.781 44h18.438c.92 0 1.718-.623 1.94-1.516l.501-2a1.99 1.99 0 0 0-.66-2.016V33a1 1 0 0 0-1-1h-1.568l-6.841-14.923.565-.089a1 1 0 0 0 .05-1.966L36.961 11.39A2 2 0 0 0 37 11v-1c0-.808-.484-1.502-1.176-1.817C36.547 7.315 37 6.215 37 5c0-2.757-2.243-5-5-5s-5 2.243-5 5c0 1.215.453 2.315 1.176 3.183A1.999 1.999 0 0 0 27 10v1c0 .134.014.264.04.391l-1.246.262a1 1 0 1 0 .413 1.958L28 13.233v4.598L15.521 15.86l6.685-1.407a1 1 0 1 0-.413-1.957l-12 2.526a1 1 0 0 0 .05 1.966l.565.089L3.568 32H2zm45.002 30H17v-1h30l.002 1zM35 49c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm-5-31v-5h4v5h-4zm-1-8h6v1h-6v-1zm19 24v1h-5v-1h5zm13 4h-5v-1h5v1zm-7 0h-4v-4h4v4zm-11 0v-1h5v1h-5zm18.22 3.999c0 .001-.001.001 0 0L42.78 42l-.499-2H61.72l-.5 1.999zM61 35h-5v-1h5v1zm-6-3h-9.232l6.229-13.601L58.231 32H55zM36 17.83v-4.598l12.479 2.627L36 17.83zM32 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zM8 34v1H3v-1h5zm13 4h-5v-1h5v1zm-7 0h-4v-4h4v4zM3 38v-1h5v1H3zm18.22 3.999c0 .001-.001.001 0 0L2.78 42l-.499-2H21.72l-.5 1.999zM21 35h-5v-1h5v1zm-8.996-16.601L18.232 32H5.769l6.235-13.601z"
    />
  </svg>
)

export default BalanceScaleIcon
